export function FieldError({ id, message }: { id?: string; message?: string }) {
  if (!message) return null

  return (
    <p id={id} className="form-error" role="alert">
      {message}
    </p>
  )
}
